import React from "react";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { COUNTRY_CODE_LIST } from "../../config/constants";

const PhoneNumberInput = React.forwardRef(
  ({ selectedCountry, onCountryChangeHandler, onInputChange, optional = false, placeholder = "Enter phone number", primaryColor, themeMode, ...props }, ref) => {
    const selectedCountryObj = COUNTRY_CODE_LIST.find(country => country.id === selectedCountry);
    const dynamicPlaceholder = selectedCountryObj ? selectedCountryObj.code : placeholder;

    // Compose onInputChange (country detection) with RHF's onChange
    const handleChange = (e) => {
      if (props.onChange) props.onChange(e);
      if (onInputChange) onInputChange(e.target.value);
    };

    return (
      <div>
        <label
          htmlFor="phone-number"
          className="block text-sm/6 font-medium text-themed-primary"
        >
          Phone number
          {optional && (
            <span className="ml-1 font-normal text-themed-secondary">(optional)</span>
          )}
        </label>
        <div className="mt-2">
          <div className="flex rounded-card bg-themed-card border border-themed transition-colors focus-within-themed">
            <div className="grid shrink-0 grid-cols-1 focus-within:relative">
              <select
                id="country"
                name="country"
                autoComplete="country"
                aria-label="Country"
                className="col-start-1 row-start-1 w-24 appearance-none border-0 bg-none bg-transparent py-2 pl-3 pr-7 text-base text-themed-primary sm:text-sm/6 focus:outline-none focus:ring-0"
                onChange={onCountryChangeHandler}
                value={selectedCountry}
              >
                {COUNTRY_CODE_LIST.map((country) => (
                  <option
                    key={country.id}
                    value={country.id}
                  >{`${country.flag} ${country.id}`}</option>
                ))}
              </select>
              <ChevronDownIcon
                aria-hidden="true"
                className="pointer-events-none col-start-1 row-start-1 mr-2 size-4 self-center justify-self-end text-themed-secondary"
              />
            </div>
            <input
              id="phone-number"
              name="phone-number"
              type="tel"
              autoComplete="tel"
              placeholder={dynamicPlaceholder}
              className="themed-autofill block min-w-0 grow border-0 border-l border-themed bg-transparent px-3 py-2 text-base text-themed-primary placeholder:text-themed-secondary sm:text-sm/6 focus:outline-none focus:ring-0"
              ref={ref}
              {...props}
              onChange={handleChange}
            />
          </div>
        </div>
        {props.errormessage ? (
          <div className="mt-2 text-sm text-signal-red-700">
            <p>{props.errormessage}</p>
          </div>
        ) : null}
      </div>
    );
  }
);

export default PhoneNumberInput;
